const getRouteMeta = (to, key, defaultValue) => {
	return (
		to.matched.find((macth) => {
			return key in macth.meta
		})?.meta[key] ?? defaultValue
	)
}

export { getRouteMeta }
